import React from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { doc, setDoc } from "firebase/firestore";
import Avatar from '../images/TchatAvatar.png'
import { auth, storage, db } from '../firebase'

const Register = () => {
  const [signupError, setSignupError] = React.useState('')
  const navigate = useNavigate()

  const handleSignUp = async (e) => {
    e.preventDefault()

    const { name: { value: name }, email: { value: email }, password: { value: password }, avatar: { files: [avatar] } } = e.target.elements

    try {
      const response = await createUserWithEmailAndPassword(auth, email, password)

      const storageRef = ref(storage, name);
      const uploadTask = uploadBytesResumable(storageRef, avatar);

      uploadTask.on(
        (error) => {
          setSignupError('Failed to upload the image!')
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then(async downloadURL => {
            await updateProfile(response.user, {
              displayName: name, photoURL: downloadURL
            })

            await setDoc(doc(db, "users", response.user.uid), {
              uid: response.user.uid, displayName: name, email, photoURL: downloadURL
            })

            await setDoc(doc(db, "userChats", response.user.uid), {})
            navigate('/', { replace: true })
          })
        }
      )
    } catch ({ message }) {
      setSignupError(message)
    }
  }

  return (
    <div className='flex items-center justify-center md:p-12 h-full'>
      <div className='grid lg:grid-cols-signup md:grid-cols-1 bg-white max-w-screen-lg mx-auto md:shadow-xl'>
        <div className='flex flex-col gap-16 px-16 py-16 md:px-28 md:py-24'>
          <form className='flex flex-col gap-12' onSubmit={handleSignUp}>
            <span className='!leading-snug text-justify text-title md:text-5xl mb-8 md:mb-0 tracking-tighter'>Sign up and stay connected with friends and family</span>
            <input type='text' name='name' placeholder='Display name' />
            <input type='email' name='email' placeholder='Email' />
            <input type='password' name='password' placeholder='Password' />
            <input type='file' name='avatar' className='hidden' id='avatar' />
            <label htmlFor='avatar' className='flex items-center gap-4 mb-12 md:mb-4 hover:cursor-pointer'>
              <img src={Avatar} alt='file-icon' className='h-16 w-16' />
              <span className='font-semibold text-purple-dark'>Add an avatar</span>
            </label>

            <button className='self-start px-8 py-4 md:px-10 md:py-5 text-3xl tracking-tighter bg-purple-light text-white rounded-2xl'>Sign up</button>
            {signupError && <span>{signupError}</span>}
          </form>

          <span>Already have an account? <Link to='/login' className='text-purple-dark font-semibold underline'>login</Link></span>
        </div>

        <div className='relative bg-purple-light p-16 overflow-hidden hidden lg:inline-block'>
          <span className='text-gray-100 text-9xl font-bold tracking-tighter'>Welcome to Tchat family</span>
          <span className='absolute left-4 bottom-3 text-10xl text-dark-20 font-extrabold'>Tchat.</span>
        </div>
      </div>
    </div>
  )
}

export default Register